import { h, Fragment } from "preact";
import Home2 from "../components/Home2";

import Dataroom from "../components/Dataroom";
import Contact from "../components/Contact";
import MentionsLegales from "../components/MentionsLegales";
import Login from "../components/Login";
import CGV from "../components/CGV";
import CGU from "../components/CGU";
import UserDashboard from "../components/UserDashboard";
import DealNotifications from "../components/DealNotifications";
import Notifications from "../components/Notifications";
import DealNewA from "../components/DealNew/DealNewA";
import DevenirAmbassadeur from "../components/DevenirAmbassadeur";
import Search from "../components/Search";
//import DealDashboard from "../components/DealDashboard";
import DealDashboardA from "../components/DealDashboardA";
import DealDashboardV from "../components/DealDashboardV";
import DealDashboardP from "../components/DealDashboardP";
import DealDashboardN from "../components/DealDashboardN";
import DashboardAmbassador from "../components/DashboardAmbassador";
import DashboardSeller from "../components/DashboardSeller";
import DashboardProspect from "../components/DashboardProspect";
import DashboardNotaire from "../components/DashboardNotaire";
import Appointments from "../components/DealMeetings/Appointments";
import DealUser from "../components/DealUser";
import PublicPage from "../components/PublicPage";
import UserMails from "../components/UserMails";
import DealRealEstates from "../components/RealEstate/DealRealEstates";
import DealRealEstate from "../components/RealEstate/DealRealEstate";
import AmbassadorAppointment from "../components/AmbassadorAppointment";
import InscriptionVendeur from "../components/InscriptionVendeur";
import Inscription from "../components/Inscription";
import DevenirVendeur from "../components/DevenirVendeur";
import DevenirAcquereur from "../components/DevenirAcquereur";
import Sellers from "../components/Sellers";
import Buyers from "../components/Buyers";
import ConfirmPhone from "../components/ConfirmPhone";
import User from "../components/User";
import DealNewV from "../components/DealNew/DealNewV";
import PwdSet from "../components/PwdSet";
import DocSign from "../components/DocSign";
import ConfirmedEmail from "../components/ConfirmedEmail";
import Makepublic from "../components/Makepublic";
import Offers from "../components/Offers";
import InviteNotary from "../components/InviteNotary";

import { Support } from "../components/support/Support"

import KIcon from "../components/Icons/KIcon";
import { Box, Button, Fab, Fade, Paper, Popper, Stack, TextareaAutosize, Typography, } from "@mui/material";

import ReactGA from "react-ga4";
ReactGA.initialize("G-YEDC8PZB9J");

const SwitchComponent = (props) => {
	//console.log("switchComponent", props);
	switch (props.path) {
		case "/":
			return <Home2 />;
			break;
		case "/inscription":
			return <Inscription />;
			break;
		case "/devenir-ambassadeur":
			return <DevenirAmbassadeur {...props} />;
			break;
		case "/devenir-ambassadeur/:step":
			return <DevenirAmbassadeur {...props} />;
			break;
		case "/dashboard":
			return <UserDashboard />;
			break;
		case "/user":
			return <User {...props} />;
			break;
		case "/search":
			return <Search />;
		case "/contact":
			return <Contact />;
			break;
		case "/dataroom/:id":
			return <Dataroom id={props.id} {...props} />;
			break;
		case "/mentions-legales":
			return <MentionsLegales />;
			break;
		case "/cgv":
			return <CGV />;
			break;
		case "/setpwd":
			return <PwdSet {...props} />;
			break;
		case "/cgu":
			return <CGU />;
			break;
		case "/login":
			return <Login />;
			break;
		case "/unotifs":
			return <Notifications />;
			break;
		case "/make-public/:id":
			return <Makepublic id={props.id} />;
			break;
		case "/mails":
			return <UserMails />;
			break;
		case "/offers/:id":
			return <Offers uid={props.id} />;
			break;
		case "/dnotifs":
			return <DealNotifications />;
			break;
		case "/newdeala/:id/:step":
			return <DealNewA {...props} />;
			break;
		case "/newdealv/:id/:step":
			return <DealNewV {...props} />;
			break;
		case "/du/:id":
			return <DealUser uid={props.id} {...props} />;
			break;
		case "/sellers/:id":
			return <Sellers uid={props.id} {...props} />;
			break;
		case "/buyers/:id":
			return <Buyers uid={props.id} {...props} />;
			break;
		case "/dashboardv":
			return <DashboardSeller />;
			break;
		case "/dashboarda":
			return <DashboardAmbassador {...props} />;
			break;
		case "/dashboardp":
			return <DashboardProspect />;
			break;
		case "/dashboardn":
			return <DashboardNotaire />;
			break;
		case "/dre0/:id/:step":
			return <DealRealEstate {...props} />;
			break;
		case "/deal/:id":
			return <DealDashboard id={props.id} />;
			break;
		case "/dre/:id":
			return <DealRealEstates id={props.id} />;
			break;
		case "/7bac6cb9d6ee4d70b1315393725f3a34/:id":
			return <DealDashboardA {...props} />;
			break;
		case "/508f2de0fa994052a6d0cbc0c3b4d8c7/:id":
			return <DealDashboardN {...props} />;
			break;
		case "/11d1355181ac4376a09980601b420617/:id":
			return <DealDashboardV {...props} />;
			break;
		case "/1fdf58e512f54752959b369588380557/:id":
			return <DealDashboardP {...props} />;
			break;
		case "/e668ce390be04a6b88aa54d048a49b55/:uid":
			return <Appointments uid={props.uid} {...props} />;
			break;
		case "/e668ce390be04a6b88aa54d048a49b55":
			return <Appointments  {...props} />;
			break;
		case "/publicpage/:id":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <PublicPage id={props.id} />;
			break;
		case "/apt/:id":
			return <AmbassadorAppointment id={props.id} />;
			break;
		case "/trouver-un-bien-a-paris-a8e41f":
			return <Search />;
			break;

		case "/inscription-vendeur":
			return <InscriptionVendeur />;
			break;

		case "/devenir-acquereur/:step":
			return <DevenirAcquereur {...props} />;
			break;
		case "/devenir-vendeur/:step":
			return <DevenirVendeur {...props} />;
			break;
		case "/confirmphone/:id":
			return <ConfirmPhone id={props.id} />;
			break;
		case "/signdoc/:id":
			return <DocSign id={props.id} />;
			break;
		case "/invite-notary-seller/:id":
			return <InviteNotary id={props.id} mode="V" />;
			break;
		case "/signdoc/:id":
			return <DocSign id={props.id} />;
			break;
		case "/trouver-des-biens/:id?":
			return <Search {...props} />;
			break;

		case "/confirmed-email/:mode":
			return <ConfirmedEmail mode={props.mode} />;
			break;

		case "/support":
			return <Support />;
			break;
	}
};
import { useState, useEffect } from "preact/hooks";


export default function WithMainTheme2(props) {

	return (<div style="margin-top: 90px; ">
		<SwitchComponent {...props} />
		<Fab color="primary" aria-label="add" style={{
			position: 'fixed',
			bottom: 16,
			right: 16,
			border: "1px white solid",

		}}>
			<PositionedPopper />
		</Fab>
	</div>)

}

function PositionedPopper() {
	const [anchorEl, setAnchorEl] = useState(null);
	const [open, setOpen] = useState(false);
	const [placement, setPlacement] = useState();
	const [disabled, setDisabled] = useState(true);
	const [state, setState] = useState({ step: "step1" });

	const handleClick = (newPlacement) => (event) => {
		setAnchorEl(event.currentTarget);
		setOpen((prev) => placement !== newPlacement || !prev);
		setPlacement(newPlacement);
	};

	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.value })
	};

	useEffect(() => {
		setDisabled(!state.comment)
	}, [state])
	const sendComment = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(state)
		};
		fetch("/api/2b6ef5fa9e72437fb28743036d545155/", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<div>
			<Popper open={open} anchorEl={anchorEl} placement={placement} transition>
				{({ TransitionProps }) => (
					<Fade {...TransitionProps} timeout={350}>
						<Paper sx={{ padding: "10px", marginBottom: "20px", borderColor: "red", boxShadow: "0px 0px 5px 0px red;" }}>

							{state.step === "step1" && <Stack spacing={1}>
								<Typography variant="h5">Commentaire, avis, suggestion...</Typography>
								<TextareaAutosize
									name="comment"
									aria-label="comment"
									minRows={6}
									placeholder="Vous pouvez nous faire part de toutes vos remarques."
									style={{ width: 250 }}
									onChange={handleChange}
									value={state.comment}
								/>
								<Button disabled={disabled} variant="contained" onClick={() => { sendComment(); setState({ ...state, step: "step2" }) }}>Envoyer</Button>
							</Stack>}
							{state.step === "step2" && <Stack spacing={1}><Typography>Merci !!</Typography>

								<Button disabled={disabled} variant="contained" onClick={() => { setOpen(false); setState({ ...state, comment: undefined, step: "step1" }) }}>Fermer</Button>
							</Stack>}
						</Paper>
					</Fade>
				)}
			</Popper>

			<KIcon height={40} width={40} fill="#FFF" onClick={handleClick('top-end')} style="cursor: pointer; " />
		</div >
	);
}